// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Autoplay, Grid } from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay, Grid]);

const partnersSwiper = new Swiper('.js-partners-swiper', {
  navigation: {
    nextEl: '.js-partners-button-next',
    prevEl: '.js-partners-button-prev'
  },
  loop: true,
  slidesPerView: 6,
  spaceBetween: 76,
  grabCursor: true,

  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 0,
      loop: true,
      grid: {
        rows: 3,
      },
    },
    481: {
      slidesPerView: 3,
      spaceBetween: 40,

      grid: {
        rows: 0,
        fill: 'column'
      },
    },
    767: {
      slidesPerView: 4,
      spaceBetween: 40
    },
    992: {
      slidesPerView: 5,
      spaceBetween: 50
    },
    1024: {
      slidesPerView: 6,
      spaceBetween: 60
    },
    1280: {
      slidesPerView: 6,
      spaceBetween: 76
    },
  }
});

dl.log(partnersSwiper);

const cards3Swiper = new Swiper('.js-3-cards-swiper', {
  navigation: {
    nextEl: '.js-3-cards-button-next',
    prevEl: '.js-3-cards-button-prev'
  },
  loop: true,
  slidesPerView: 3.35,
  spaceBetween: 17,
  grabCursor: true,

  breakpoints: {
    0: {
      slidesPerView: 1.55,
      spaceBetween: 13
    },
    475: {
      slidesPerView: 2.4
    },
    767: {
      slidesPerView: 2.9,
      spaceBetween: 17
    },
    992: {
      slidesPerView: 3.1
    },
    1024: {
      slidesPerView: 3.35
    }
  }
});

dl.log(cards3Swiper);

const testimonialsSwiper = new Swiper('.js-testimonials-swiper', {
  navigation: {
    nextEl: '.js-testimonials-button-next',
    prevEl: '.js-testimonials-button-prev'
  },
  loop: true,
  slidesPerView: 2,
  spaceBetween: 17,
  grabCursor: true,

  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 10
    },
    767: {
      slidesPerView: 2,
      spaceBetween: 28
    },
  }
});

dl.log(testimonialsSwiper);

document.querySelectorAll('.image-slider').forEach(n => {
  new Swiper(n.querySelector('.js-image-swiper'), {
    navigation: {
      nextEl: n.querySelector('.js-image-button-next'),
      prevEl: n.querySelector('.js-image-button-prev')
    },
    pagination: {
      el: n.querySelector('.js-image-swiper-pagination'),
      clickable: true
    },
    slidesPerView: 1.12,
    centeredSlides: true,
    initialSlide: 1,
    grabCursor: true,
    spaceBetween: 0
  });
});
